<template>
     <div class="dailyactivitie-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Daily Activities" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="dailyactivitie-id" type="hidden" v-model="dailyactivitie.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Date:"
                    label-for="dailyactivitie-activities_date_activitie"
                    >
                    <b-form-input
                    id="dailyactivitie-activities_date_activitie"
                    type="date"
                    v-model="dailyactivitie.activities_date_activitie"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
             </b-row>
              <b-row>
                 <b-col md="12" sm="12">
                        <b-form-group 
                            label="Global Comments:" 
                            label-for="dailyactivitie-comments_activitie">
                        <b-form-textarea id="dailyactivitie-comments_activitie"
                            :rows="3"
                            :max-rows="3"
                            size="sm"
                            v-model="dailyactivitie.comments_activitie"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>   

               <b-card class="owner-search-card">
                     <b-tabs card >
                         <b-tab title="Detail Activities" active> 
                             <b-row>
                                <b-button  
                                    title="Add Activities" 
                                    size="sm" 
                                    class="mb-2 fa fa-plus" 
                                    variant="dark" 
                                    v-if="dailyactivitie.id > 0"
                                    @click="openModalDailyActivitieItem">
                                 </b-button>
                            </b-row>   
                                <transition  name="slide" type="animation" appear>       
                                    <b-table 
                                        class="table-responsive" 
                                        hover 
                                        key="slide"  
                                        head-variant="light" 
                                        :items="dailyacitivitieitems" 
                                        :fields="fieldDailyActivitieItem">
                                        <template v-slot:cell(actions)="data">
                                            <b-button 
                                                title="Edit" 
                                                size="sm" 
                                                variant="light" 
                                                @click="[loadDailyActivitieItem(data.item),openModalDailyActivitieItem()]" class="mr-2 mt-2">
                                                <i class="fa fa-pencil"></i>
                                            </b-button>
                                             <b-button 
                                                title="Delete" 
                                                size="sm" 
                                                variant="light" 
                                                @click="showMsgBoxDeleteDailyActivitieItem(data.item)" 
                                                class="mr-2 mt-2">
                                            <i class="fa fa-trash"></i>
                                            </b-button>
                                        </template>
                                    </b-table>
                                </transition>  
                            </b-tab>
                     </b-tabs>
               </b-card>


        <br>

         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadActivities(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br> 
              <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Start Date:"
                    label-for="dailyactivitie-start_date"
                    >
                    <b-form-input
                    id="dailyactivitie-start_date"
                    type="date"
                    v-model="start_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="End Date:"
                    label-for="dailyactivitie-end_date"
                    >
                    <b-form-input
                    id="dailyactivitie-end_date"
                    type="date"
                    v-model="end_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
             </b-row> 
        <b-row>   
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="dailyactivities" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadActivitie(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadActivitie(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadActivitie(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
      <b-modal
            id="modalDailyActivitieItem"
            ref="modal"
            title-tag="h6"
            title="Detail Activities"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveDailyItem"
        >
            <b-form>
                  <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                                label="Description:" 
                                label-for="dailyacitivitieitem-description_daily_activitie">
                            <b-form-input id="dailyacitivitieitem-description_daily_activitie" 
                                type="text"
                                v-model="dailyacitivitieitem.description_daily_activitie" 
                                size="sm"
                                placeholder="Description..." />
                        </b-form-group>
                    </b-col>
                </b-row>   
                 <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                                label="Location:" 
                                label-for="dailyacitivitieitem-location_daily_activitie">
                            <b-form-input id="dailyacitivitieitem-location_daily_activitie" 
                                type="text"
                                v-model="dailyacitivitieitem.location_daily_activitie" 
                                size="sm"
                                placeholder="Location..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                                label="Responsible Executor:" 
                                label-for="dailyacitivitieitem-responsible_executor_daily_activitie">
                            <b-form-input id="dailyacitivitieitem-responsible_executor_daily_activitie" 
                                type="text"
                                v-model="dailyacitivitieitem.responsible_executor_daily_activitie" 
                                size="sm"
                                placeholder="Responsible Executor..." />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="4" sm="12">
                        <b-form-group
                        label="In:"
                        label-for="dailyacitivitieitem-date_in_daily_activitie"
                        >
                        <b-form-input
                        id="dailyacitivitieitem-date_in_daily_activitie"
                        type="time"
                        v-model="dailyacitivitieitem.date_in_daily_activitie"
                        size="sm"
                        />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                        label="Out:"
                        label-for="dailyacitivitieitem-date_out_daily_activitie"
                        >
                        <b-form-input
                        id="dailyacitivitieitem-date_out_daily_activitie"
                        type="time"
                        v-model="dailyacitivitieitem.date_out_daily_activitie"
                        size="sm"
                        />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Addtional Value:"
                            label-for="dailyacitivitieitem-addtional_value_daily_activitie"
                        >
                            <b-form-input
                                id="dailyacitivitieitem-addtional_value_daily_activitie"
                                type="number"
                                v-model="dailyacitivitieitem.addtional_value_daily_activitie"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                 <b-row>
                 <b-col md="12" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="dailyacitivitieitem-comments_daily_activitie">
                        <b-form-textarea id="dailyacitivitieitem-comments_daily_activitie"
                            :rows="6"
                            :max-rows="12"
                            size="sm"
                            v-model="dailyacitivitieitem.comments_daily_activitie"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>   
            </b-form>
      </b-modal>
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'DailyActivitieUser',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                dailyactivitie: {},
                dailyacitivitieitem:{},
                dailyactivities: [],
                dailyacitivitieitems:[],
                perPage: 50,
                currentPage: 1,
                start_date:null,
                end_date:null,
                user_id_activitie:null,
                isBusy: false,
                showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                    { key: 'activities_date_activitie',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'comments_activitie', label: 'Comments', sortable: true,variant: 'light' },
                                            
                { key: 'actions', label: 'Action',variant: 'light' },

                ],
                fieldDailyActivitieItem: [
                    { key: 'description_daily_activitie', label: 'Description', sortable: true ,variant: 'light'},   
                    { key: 'location_daily_activitie', label: 'Location', sortable: false ,variant: 'light'},   
                    { key: 'responsible_executor_daily_activitie', label: 'Responsible Executor', sortable: false ,variant: 'light'},   
                     {key: 'date_in_daily_activitie',label: 'In',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('HH:mm') : '',variant: 'light'
                    },
                    {key: 'date_out_daily_activitie',label: 'Out',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('HH:mm') : '',variant: 'light'
                    },
                    { key: 'addtional_value_daily_activitie', label: 'Addtional Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'actions', label: 'Action',variant: 'light' }
                ],
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.dailyactivities.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDate(date) {
                return moment(date)
                    .format('YYYY-MM-DD')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },   
            async showMsgBoxDeleteDailyActivitieItem(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeDailyActivitieItem(item)
                    }
                })
            },       
            loadActivities(){

                const url = `${baseApiUrl}/dailyactivitiesbyuser/${this.user.id}?start_date=${this.start_date}&end_date=${this.end_date}`
                axios(url).then(res =>{
                     this.dailyactivities = res.data
                      this.isBusy = false
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.dailyactivitie = {}
            },
             reset() {
                this.mode = 'insert'
                this.loadActivities()
                this.dailyactivitie = {}
            },
            async save() {

                const method = this.dailyactivitie.id ? 'put' : 'post'
                const id = this.dailyactivitie.id ? `/${this.dailyactivitie.id}` : ''

                this.dailyactivitie.user_id_activitie = this.user.id

                this.dailyactivitie.company_id_activitie = this.compan.id
                

                await axios[method](`${baseApiUrl}/dailyactivities${id}`, this.dailyactivitie)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            async saveDailyItem(){
                 const method = this.dailyacitivitieitem.id ? 'put' : 'post'
                const id = this.dailyacitivitieitem.id ? `/${this.dailyacitivitieitem.id}` : ''

                this.dailyacitivitieitem.daily_acitivitie_id = this.dailyactivitie.id

                 await axios[method](`${baseApiUrl}/dailyacitivitieitems${id}`, this.dailyacitivitieitem)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadDailyActivitieItems()
                        this.dailyacitivitieitem = {}
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.dailyactivitie.id
                    axios.delete(`${baseApiUrl}/dailyactivities/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeDailyActivitieItem(item) {
                    const id = item.id
                    axios.delete(`${baseApiUrl}/dailyacitivitieitems/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadDailyActivitieItems()
                        })
                        .catch(showError)
            },
            loadActivitie(dailyactivitie, mode = 'save') {
                this.mode = mode
                if(dailyactivitie.activities_date_activitie) dailyactivitie.activities_date_activitie = this.formatDate(dailyactivitie.activities_date_activitie)
            
                this.dailyactivitie = { ...dailyactivitie }
                this.loadDailyActivitieItems()
                this.$refs.searchFocus.focus();
                
            },
            loadDailyActivitieItems(){
                const url = `${baseApiUrl}/dailyacitivitieitemsbydailyactivitie/${this.dailyactivitie.id}`
                axios(url).then(res =>{
                     this.dailyacitivitieitems = res.data
                })

            },
            openModalDailyActivitieItem() {
                this.$bvModal.show('modalDailyActivitieItem')
            },
            loadDailyActivitieItem(item) {
                this.dailyacitivitieitem = {
                    ...item,
                    date_in_daily_activitie: moment(item.date_in_daily_activitie).format("HH:mm"),
                    date_out_daily_activitie: moment(item.date_out_daily_activitie).format("HH:mm")
                    }
            },
          
        },
        mounted(){

                this.start_date = moment().startOf('month').format("YYYY-MM-DD");
                this.end_date = moment().endOf('month').format("YYYY-MM-DD");

            this.loadActivities()
            this.showTable = true
        }
}
</script>

<style>


    .dailyactivitie-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .dailyactivitie-search button{
        font-size: 0.75rem;
    }

     .dailyactivitie-search select{
        font-size: 0.75rem;
    }

    .dailyactivitie-search input{
        font-size: 0.75rem;
    }

    .dailyactivitie-search textarea{
        font-size: 0.75rem;
    }

    

    .dailyactivitie-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }

    #modalDailyActivitieItem input{
        font-size: 0.75rem;
    }

    #modalDailyActivitieItem select{
        font-size: 0.75rem;
    }

    #modalDailyActivitieItem label{
        font-size: 0.75rem;
        color: black;
    }

    #modalDailyActivitieItem textarea{
        font-size: 0.75rem;
    }

       #modalDailyActivitieItem button{
        font-size: 0.75rem;
    }
  
 

    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
